import React, { useState } from "react";
import { ArrowLeft, Check, Copy, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function Support() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const email = "support@blu-pay.co";

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // The visible email can still be selected and copied manually.
    }
  };

  return (
    <main className="min-h-screen bg-[#F7F8F3] text-[#0A4730]">
      <div className="max-w-3xl mx-auto px-6 py-8 md:py-14">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-sm font-medium text-[#0A4730]/70 hover:text-[#0A4730] transition-colors"
        >
          <ArrowLeft size={18} />
          Back
        </button>

        <section className="mt-16 md:mt-24 text-center">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-[#C0F6B7] flex items-center justify-center">
            <Mail size={25} strokeWidth={2} />
          </div>

          <p className="mt-7 text-[10px] uppercase tracking-[0.22em] font-semibold text-[#0A4730]/50">
            BluPay Support
          </p>

          <h1 className="mt-3 font-serif text-4xl md:text-5xl font-semibold tracking-tight">
            How can we help?
          </h1>

          <p className="mt-5 max-w-lg mx-auto text-sm md:text-base leading-7 text-[#0A4730]/65">
            If you have a question about your account, verification, or a
            transfer, contact our support team and we’ll be happy to help.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <a
              href={`mailto:${email}`}
              className="inline-flex items-center justify-center gap-3 rounded-2xl bg-[#0A4730] px-7 py-4 text-sm font-semibold text-white shadow-sm hover:bg-[#083b29] transition-colors select-text"
            >
              <Mail size={18} />
              <span>{email}</span>
            </a>

            <button
              type="button"
              onClick={copyEmail}
              aria-label="Copy support email address"
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-[#0A4730]/15 bg-white px-5 py-4 text-sm font-semibold text-[#0A4730] hover:bg-[#C0F6B7]/30 transition-colors"
            >
              {copied ? <Check size={18} /> : <Copy size={18} />}
              {copied ? "Copied" : "Copy email"}
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
